/**
 * HTTP Status Code Constants
 *
 * Enum constants for commonly used HTTP status codes to improve code readability
 * and maintainability by replacing magic numbers with descriptive constants.
 */
export enum HttpStatusCode {
  // Success
  OK = 200,
  CREATED = 201,

  // Client Errors
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  GONE = 410,
  UNPROCESSABLE_ENTITY = 422,

  // Server Errors
  INTERNAL_SERVER_ERROR = 500,
}
